import { Directive, HostListener, ElementRef, Input, HostBinding } from '@angular/core';

@Directive({
  selector: '[OnlyLetters]'
})
export class OnlyLettersDirective {

  teclaAnterior: string = "";

  constructor(private element: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeydownHandler(event: any) {

    const charCode = (event.which) ? event.which : event.keyCode;

    //if (event.currentTarget.id == "nombres") {
    //  this.teclaAnterior = this.teclaAnterior + " " + event.keyCode;
    //  let arregloTA = this.teclaAnterior.split(" ");
    //  if (event.keyCode == 32 && arregloTA[arregloTA.length - 2] == '32') {
    //    event.preventDefault();
    //  }
    //  if (charCode == 32) {
    //    return true;
    //  }
    //}
    if (charCode >= 65 && charCode <= 90) {
      return true;
    //} else if (charCode >= 97 && charCode <= 122) {
    //  return true;
    } else if (charCode == 91 || (charCode >= 96 && charCode <= 105)) {
      return false;
    } else if (charCode >= 160 && charCode <= 165) {
      return true;
    } else if (charCode == 39 || charCode == 44 || charCode == 103 ||
      charCode == 129 || charCode == 193 || charCode == 201 || charCode == 180 ||
      charCode == 205 || charCode == 211 || charCode == 218 || charCode == 225 ||
      charCode == 233 || charCode == 237 || charCode == 243 || charCode == 250 ||
      charCode == 241 || charCode == 209 || charCode == 32 || charCode == 8) {
      return true;
    }
    return false;
  }

}
